module.exports = __webpack_public_path__ + "img/product-forbidden-3.f8fb7842.png";